export default function proptechAuth(
  initialState = {
    loggedIn: false,
  },
  action
) {
  switch (action.type) {
    case 'PROPTECH_AUTH_LOGIN_SUCCESS':
      return {
        ...initialState,
        loggedIn: true,
      };

    case 'PROPTECH_AUTH_LOGIN_FAILED':
      return {
        ...initialState,
        loggedIn: false,
      };

    case 'PROPTECH_AUTH_RESET':
      return {
        ...initialState,
        loggedIn: false,
      };

    default:
      return initialState;
  }
}
